import { Injectable } from '@angular/core';
import {
  Criteria,
  PaginationHelper,
} from '@daas-consulting/core-cross-interfaces';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { loader } from '@daas-consulting/production/shared/frontend/store';
import { Selector } from '@ngxs/store';
import { cases } from './remitos-list.defaults';
import { defaultFilter, RemitosListState } from './remitos-list.state';
import { Filter, RemitosListStateModel } from './remitos-list.state-model';

@Injectable()
export class RemitosSelectors {
  private static initialFilter: string =
    RemitosSelectors._filterToString(defaultFilter);

  private static _filterToString(filter: Filter = defaultFilter): string {
    return `${filter.printNumber}|${filter.status}|${filter.date_from}|${filter.date_to}`;
  }

  @Selector([RemitosListState])
  static items(state: RemitosListStateModel): models.RemitoListItemModel[] {
    return state.pagedList.items;
  }

  @Selector([RemitosListState])
  static activeFilters(state: RemitosListStateModel): Criteria[] {
    return state.activeFilterCriteria.map((x) => ({
      ...x,
      value: cases.get(x.key)?.get(x.value) || x.value,
    }));
  }

  @Selector([RemitosListState])
  static filter(state: RemitosListStateModel): Filter | null {
    return state.filterForm.model;
  }

  @Selector([RemitosSelectors.filter])
  static isResetDisabled(state: Filter | null): boolean {
    const current = RemitosSelectors._filterToString(state as Filter);
    return RemitosSelectors.initialFilter === current;
  }

  @Selector([RemitosListState])
  static currentFilterAsString(state: RemitosListStateModel): string {
    return RemitosSelectors._filterToString(state.filterForm.model as Filter);
  }

  @Selector([RemitosListState])
  static activeFilterAsString(state: RemitosListStateModel): string {
    return RemitosSelectors._filterToString(state.activeFilterModel);
  }

  @Selector([
    RemitosSelectors.currentFilterAsString,
    RemitosSelectors.activeFilterAsString,
    loader.selectors.LoaderSelectors.isLoading,
  ])
  static isApplyDisabled(
    currentFilter: string,
    activeFilter: string,
    isLoading: boolean
  ): boolean {
    return currentFilter === activeFilter || isLoading;
  }

  @Selector([RemitosListState])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static pageSizeOptions(_state: RemitosListStateModel): number[] {
    return [5, 10, 15, 25, 50];
  }

  @Selector([RemitosListState])
  static _activePageSize(state: RemitosListStateModel): number | undefined {
    return state.activePageSize;
  }

  @Selector([RemitosSelectors._activePageSize])
  static activePageSize(state: number | undefined): number {
    const { pageSize } = PaginationHelper.sanitize({ pageSize: state });
    return pageSize;
  }

  @Selector([RemitosListState])
  static _activePageIndex(state: RemitosListStateModel): number | undefined {
    return state.activePageIndex;
  }

  @Selector([RemitosSelectors._activePageIndex])
  static activePageIndex(state: number | undefined): number {
    const { pageIndex } = PaginationHelper.sanitize({ pageIndex: state });
    return pageIndex;
  }

  @Selector([RemitosListState])
  static totalItems(state: RemitosListStateModel): number {
    return state?.pagedList?.totalItemCount || 0;
  }
}
